import { useMemo } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useSalesUnits } from "@/hooks/use-sales-units";
import { collectSalesPeople } from "@/hooks/use-sales-dashboard-data";
import { usePersonFilter } from "@/contexts/dashboard-filter-context";

const TEAM_VALUE = "__team__";

/**
 * Person picker for the sales dashboard (F0.2). "Hele teamet" or a single sales
 * owner. Drives PersonFilterContext. Owners are the members of the sales units
 * (the sales team) — the natural filter list for a sales dashboard.
 */
export function PersonSelector() {
  const { selectedUserId, setSelectedUserId } = usePersonFilter();
  const { data: units = [] } = useSalesUnits();
  const people = useMemo(() => collectSalesPeople(units), [units]);

  return (
    <Select
      value={selectedUserId ?? TEAM_VALUE}
      onValueChange={(v) => setSelectedUserId(v === TEAM_VALUE ? null : v)}
    >
      <SelectTrigger className="w-56" aria-label="Velg person">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={TEAM_VALUE}>Hele teamet</SelectItem>
        {people.map((p) => (
          <SelectItem key={p.userId} value={p.userId}>
            {p.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
